import styles from './styles.module.scss'
import FilterSidePanel from './FiltersSidePanel'
import { FilterOption } from 'types/filters'
import { FilterBuild } from './FiltersSidePanel/types'
import { useCallback, useState, useEffect, useContext } from 'react'
import { getCollectionFiltersState } from '../helpers'
import { getFiltersOptionsState } from '@helpers/filters'

import { updateFilterBuild } from '@helpers/collections/adapter/updateFilterBuild'
import { useFit } from '@helpers/hooks/useFit'
import CollectionContext from '../collectionContext'

type NewCollectionFilterProps = {
  filterBuild: FilterBuild
  onApplyFitToggle: (state: boolean) => void
  onFilterClear: () => void
  onFilterApply: (args: FilterOption[]) => void
  filterOptions: FilterOption[]
}

export default function CollectionFilter({
  filterOptions,
  filterBuild,
  onFilterClear,
  onApplyFitToggle,
  onFilterApply: handleFilterApply
}: NewCollectionFilterProps) {
  const [selectedFilterOptions, setSelectedFilterOptions] =
    useState<FilterOption[]>(filterOptions)
  const { savedFit } = useFit()
  const { setIsFitFilterToggleActive } = useContext(CollectionContext)
  const filterBuildState = updateFilterBuild(filterBuild, selectedFilterOptions)

  useEffect(() => {
    setSelectedFilterOptions(filterOptions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterOptions])

  const handleFilterSelect = () => {
    return (fitAttribute: string) => {
      return (selectedOption: string) => {
        setSelectedFilterOptions(prev =>
          getCollectionFiltersState(prev, fitAttribute, selectedOption)
        )
        setIsFitFilterToggleActive(false)
      }
    }
  }

  const handleFilterClear = useCallback(() => {
    setSelectedFilterOptions([])
    onFilterClear()
    onApplyFitToggle(false)
  }, [onFilterClear])

  const handleApplyFitToggle = useCallback(
    (state: boolean) => {
      onApplyFitToggle(state)

      if (!state) return setSelectedFilterOptions([])

      setSelectedFilterOptions(savedFit ? getFiltersOptionsState(savedFit) : [])
    },
    [onApplyFitToggle]
  )

  const onHandleFilterApply = () => {
    handleFilterApply(selectedFilterOptions)
  }

  return (
    <div className={styles.filter__container}>
      <FilterSidePanel
        filters={filterBuildState}
        selectedFilterOptions={selectedFilterOptions}
        onFilterChange={handleFilterSelect}
        onFilterApply={onHandleFilterApply}
        onFilterClear={handleFilterClear}
        onApplyFitToggle={handleApplyFitToggle}
      />
    </div>
  )
}
